import { Avatar, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import { SelectEmployee } from "components/SelectEmployee";
import DataTable from "examples/Tables/DataTable";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";

export function LeaveTransactionComponent({ employees, reload, leaveAdmin, adminFilters }) {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(moment().format("YYYY-MM"));
  const effectiveEmployee = adminFilters?.employee || selectedEmployee;
  const effectiveMonth = adminFilters?.month || selectedMonth;

  useEffect(() => {
    getLeaveTransaction();
  }, [reload, selectedEmployee, selectedMonth, leaveAdmin, adminFilters]);
  // get Leave Transaction
  async function getLeaveTransaction() {
    const params = new URLSearchParams();
    if (leaveAdmin) {
      if (effectiveEmployee) {
        params.append("employee", effectiveEmployee);
      }
      if (effectiveMonth) {
        const [year, month] = effectiveMonth.split("-");
        params.append("year", year);
        params.append("month", month);
      }
    }
    var res = await ApiCalls.getLeaveTransactions(params.toString() ? `?${params.toString()}` : undefined);
    if (res.success && res.code == 200) {
      leaveTransactionData.rows = res.data;
      leaveTransactionData.rows = leaveTransactionData.rows.map((e) => ({
        ...e,
        firstname: e?.employee?.user?.firstname || employees?.find((emp) => emp.id == e?.employee)?.user?.firstname,
        lastname: e?.employee?.user?.lastname || employees?.find((emp) => emp.id == e?.employee)?.user?.lastname,
      }));
      setLeaveTransactionData({ ...leaveTransactionData });
    }
  }

  // Refresh Transactions
  async function validateLeaveTransaction(e) {
    var obj = { employee_id: e };
    var res = await ApiCalls.postValidateLeaveTransaction(obj, false);
    if (res.success && res.code == 200) {
    }
  }
  const [leaveTransactionData, setLeaveTransactionData] = useState({
    columns: [
      {
        Header: "Added Date",
        accessor: "transaction_date",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            {moment(row.original.transaction_date).format("YYYY-MM-DD")}
          </div>
        ),
      },
      {
        Header: "Name",
        accessor: "firstname",
        Cell: ({ row }) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar src={row.original.profilePhoto} alt="Profile Photo" />
              <span style={{ marginLeft: "0.5rem" }}>
                {row.original?.firstname} {row.original?.lastname}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Transaction",
        accessor: "transaction_type",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            {row.original.transaction_type}{" "}
            {row.original.new_balance - row.original.old_balance} hours
          </div>
        ),
      },
      { Header: "Balance", accessor: "balance" },
      {
        Header: "Trc Id",
        accessor: "leave_balance",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            {row.original?.leave_balance
              ? row.original?.leave_balance
              : row.original?.leave_request}
          </div>
        ),
      },
    ],
    rows: [],
  });

  return (
    <MDBox>
      <MDBox
        pr={2}
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
      >
        {!adminFilters && (
          <SelectEmployee
            label={leaveAdmin ? "Employee" : "Refresh Transaction"}
            placeholder="Select Employee"
            onSelected={(e) => {
              if (leaveAdmin) {
                setSelectedEmployee(e);
              } else if (e) {
                validateLeaveTransaction(e);
              }
            }}
          />
        )}
        {leaveAdmin && !adminFilters && (
          <TextField
            type="month"
            label="Month"
            value={selectedMonth}
            onChange={(event) => setSelectedMonth(event.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 180, ml: 2 }}
          />
        )}
      </MDBox>
      <DataTable table={leaveTransactionData} canSearch></DataTable>
    </MDBox>
  );
}
